/* Grey Chapel — gc-ui.js
   Collapsibles, mobile tab bar, form bot filter, review photo viewer. See docs/gc-ui.md. */
(function () {
  'use strict';
  var GC = window.GC;
  if (!GC) return;

  /* #je0yr ---------------- Animated collapsibles ---------------- */

  /* Animates <details> between 0 and its measured pixel height, holding `open` for the
     duration of a close. Pixels not the 0fr->1fr grid trick: interpolating `fr`
     re-resolves the track every frame and stutters. Height is cleared to auto when the
     animation ends so open panels still reflow. The gc-anim flag on <html> turns the CSS
     on, so with no script the rows open natively. Shared with the FAQ section. */
  function initCollapsibles() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.querySelector('.gc-collapse')) return;
    document.documentElement.classList.add('gc-anim');

    function wrapperOf(det) {
      for (var i = 0; i < det.children.length; i++) {
        if (det.children[i].classList.contains('gc-collapse')) return det.children[i];
      }
      return null;
    }

    document.addEventListener('click', function (e) {
      var summary = e.target.closest && e.target.closest('summary');
      if (!summary) return;
      var det = summary.parentElement;
      if (!det || det.tagName !== 'DETAILS') return;
      var wrap = wrapperOf(det);
      if (!wrap) return;

      e.preventDefault();
      if (det.dataset.animating) return;
      det.dataset.animating = '1';

      /* transitionend is the normal finish, but a row inside a hidden ancestor
         never fires one — time out so the row can't get stuck mid-state. */
      var settle = function (after) {
        var done = function (ev) {
          if (ev && ev.propertyName !== 'height') return;
          wrap.removeEventListener('transitionend', done);
          clearTimeout(timer);
          wrap.style.height = '';
          delete det.dataset.animating;
          if (after) after();
        };
        var timer = setTimeout(done, 450);
        wrap.addEventListener('transitionend', done);
      };

      if (det.open) {
        wrap.style.height = wrap.scrollHeight + 'px';
        void wrap.offsetHeight;                 /* flush, so 0 animates from a real value */
        wrap.style.height = '0px';
        settle(function () { det.open = false; });
      } else {
        det.open = true;
        wrap.style.height = '0px';
        void wrap.offsetHeight;
        wrap.style.height = wrap.scrollHeight + 'px';
        settle();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { GC.safe(initCollapsibles); });
  else GC.safe(initCollapsibles);

  /* #w3m9x ---------------- Menu drawer (header "Phone navigation" = menu button) ----------------
     Back closes it through GC.backLayer. A link inside unwinds that history entry before it navigates, so Back from the next page lands here once, not twice. */
  GC.safe(function () {
    var root = document.querySelector('[data-menu-drawer]');
    if (!root) return;
    var layer = GC.backLayer(function () { shut(); });
    var goTo = null;
    function isOpen() { return root.classList.contains('is-open'); }
    function shut() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gc-drawer-lock');
      if (goTo) { var href = goTo; goTo = null; location.href = href; }
    }
    function open() {
      if (isOpen()) return;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gc-drawer-lock');
      layer.open();
      var btn = root.querySelector('[data-menu-close].gc-btn-x');
      if (btn) btn.focus({ preventScroll: true });
    }
    function close() { if (isOpen()) layer.close(); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-menu-close]')) { e.preventDefault(); close(); return; }
      var a = e.target.closest('[data-menu-drawer] a[href]');
      if (a && isOpen() && !(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button)) {
        e.preventDefault();
        goTo = a.href;
        close();
        /* If the history pop never arrives, go anyway. */
        setTimeout(function () { if (goTo) shut(); }, 600);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* #s2k7w ---------------- Live search suggestions (theme setting) ----------------
     Stale requests are aborted, and a late answer for an older query is dropped by sequence number. See docs/search.md. */
  GC.register('form[data-predict]', function (form) {
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-predict-results]');
    if (!input || !box || !window.fetch || !window.DOMParser) return;
    var timer = 0, seq = 0, ctl = null;
    box.id = box.id || 'gc-predict-' + Math.random().toString(36).slice(2, 7);
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');

    function show(on) { box.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    function reset() { if (ctl) ctl.abort(); seq++; show(false); box.innerHTML = ''; }
    function run(q) {
      var my = ++seq;
      if (ctl) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      var url = GC.root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,tag,product_type&section_id=predictive-search';
      var guard = ctl && setTimeout(function () { ctl.abort(); }, 8000);
      box.setAttribute('aria-busy', 'true');
      fetch(url, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          if (my !== seq) return;
          var body = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predict-body]');
          if (!body) throw new Error('the predictive-search section is missing [data-predict-body]');
          box.innerHTML = body.innerHTML;
          box.removeAttribute('aria-busy');
          show(true);
        })
        .catch(function (err) {
          if (my !== seq) return;
          box.removeAttribute('aria-busy');
          if (err && err.name === 'AbortError' && input.value.trim() !== q) return;
          console.error('[GC] live search failed', err);
          box.innerHTML = '<p class="gc-predict__none">Suggestions are not loading. Press Enter to search.</p>';
          show(true);
        })
        .then(function () { if (guard) clearTimeout(guard); });
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { reset(); return; }
      timer = setTimeout(function () { run(q); }, 180);
    });
    /* Arrow keys walk the suggestions; Up from the first returns to the box. Enter on the box still submits the form. */
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { reset(); input.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var list = box.hidden ? [] : Array.prototype.slice.call(box.querySelectorAll('a[href]'));
      if (!list.length) return;
      e.preventDefault();
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') (list[i + 1] || list[0]).focus();
      else if (i <= 0) input.focus();
      else list[i - 1].focus();
    });
    document.addEventListener('click', function (e) { if (form.isConnected && !form.contains(e.target)) show(false); });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) show(true); });
  });

  /* #r9p5t ---------------- Load more (collection setting) ----------------
     The batch after the one on screen is fetched and its images downloaded ahead of the click; loaded batches are kept for the visit so Back rebuilds the list at once. See docs/collection.md. */
  GC.safe(function () {
    var wrap = document.querySelector('[data-load-more-wrap]');
    var btn = wrap && wrap.querySelector('[data-load-more]');
    var grid = document.querySelector('[data-collection-grid]');
    if (!btn || !grid || !window.fetch || !window.DOMParser) return;
    var pager = document.querySelector('[data-pagination]');
    var count = wrap.querySelector('[data-load-more-count]');
    var sid = btn.getAttribute('data-section-id');
    var key = 'gc-loadmore:' + location.pathname + location.search;
    var label = btn.textContent;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var thrifty = !!(conn && (conn.saveData || /2g/.test(conn.effectiveType || '')));
    var batches = 1, busy = false, loadedHtml = [];
    var ready = null, warming = null;
    wrap.hidden = false;
    if (pager) pager.hidden = true;

    function fetchBatch(url) {
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', sid);
      return fetch(u.toString())
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var more = doc.querySelector('[data-collection-grid]');
          if (!more) throw new Error('no grid in the response');
          var c2 = doc.querySelector('[data-load-more-count]');
          var next = doc.querySelector('[data-load-more]');
          return { url: url, html: more.innerHTML, count: c2 ? c2.textContent : '', next: next ? next.getAttribute('href') : '' };
        });
    }

    /* #c3xv8 The design the ad-landing pin put first shows once, not again in its own batch; the tile it pushed off page 1 leads the next batch. */
    function unpin(nodes) {
      var h = grid.getAttribute('data-pinned'), gone = 0;
      if (!h) return 0;
      Array.prototype.slice.call(nodes).forEach(function (c) {
        var a = c.querySelector && c.querySelector('a[href*="/products/"]');
        var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (m && m[1] === h) { c.remove(); gone++; }
      });
      return gone;
    }
    function takeSpill() {
      var t = grid.querySelector('template[data-pin-spill]');
      if (!t) return '';
      t.remove();
      return t.innerHTML;
    }
    /* Every batch hands its last tile on to the next, so each stays a whole number of rows, until the batch that held the pinned design closes the gap. */
    var carry = takeSpill(), owed = !!carry, shown = { carry: carry, owed: owed };

    /* Built off screen, images switched to eager: a hidden eager image still downloads, and picks its <source> from the viewport as the grid would. */
    function build(b) {
      var box = document.createElement('div');
      box.className = 'gc-prewarm';
      box.setAttribute('aria-hidden', 'true');
      box.innerHTML = carry + b.html;
      carry = '';
      if (unpin(box.children)) owed = false;
      else if (owed && b.next && box.lastElementChild) {
        carry = box.lastElementChild.outerHTML;
        box.lastElementChild.remove();
      }
      b.html = box.innerHTML;
      b.hand = { carry: carry, owed: owed };
      Array.prototype.forEach.call(box.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
      grid.parentNode.insertBefore(box, grid.nextSibling);
      b.box = box;
      return b;
    }

    /* #v3h7k A click opens the grid's clip wrapper to its new height and only the new tiles rise into place; the Back restore passes animate false. */
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');
    var clip = grid.parentNode.classList.contains('gc-grid-clip') ? grid.parentNode : null;
    function reveal(b, animate) {
      var motion = animate !== false && !(calm && calm.matches);
      var h0 = clip ? clip.offsetHeight : 0;
      /* #k8fz4 Scroll anchoring off while the batch opens: with only the button on screen, Chrome anchored to it and scrolled the new rows away above the shopper. */
      var click = animate !== false;
      if (click) document.body.style.overflowAnchor = 'none';
      var release = function () { if (click) document.body.style.overflowAnchor = ''; };
      Array.prototype.slice.call(b.box.children).forEach(function (n, i) {
        if (motion) { n.classList.add('gc-reveal'); n.style.animationDelay = Math.min(i, 12) * 35 + 'ms'; }
        grid.appendChild(n);
        if (GC.progressive) GC.progressive.init(n);
        GC.boot(n);
      });
      b.box.remove();
      if (motion && clip) {
        /* The wrapper clips permanently, so nothing is toggled: the tiles already on screen are never repainted, only the strip being opened. */
        var h1 = clip.offsetHeight;
        clip.style.height = h0 + 'px';
        void clip.offsetHeight;
        clip.style.transition = 'height .6s cubic-bezier(.2, .6, .2, 1)';
        clip.style.height = h1 + 'px';
        var opened = false;
        var settle = function () {
          if (opened) return;
          opened = true;
          clip.style.height = clip.style.transition = '';
          release();
        };
        clip.addEventListener('transitionend', function te(e) {
          if (e.target !== clip || e.propertyName !== 'height') return;
          clip.removeEventListener('transitionend', te);
          settle();
        });
        setTimeout(settle, 900);
      } else requestAnimationFrame(function () { requestAnimationFrame(release); });
      if (b.count && count) count.textContent = b.count;
      if (b.next) btn.setAttribute('href', b.next); else btn.remove();
      loadedHtml.push(b.html);
      shown = b.hand;
      batches++;
      if (GC.warmTiles) GC.warmTiles();
    }

    function prewarm() {
      if (thrifty || warming || !btn.isConnected || (ready && ready.url === btn.href)) return;
      var url = btn.href;
      warming = fetchBatch(url)
        .then(function (b) { if (btn.href === url) ready = build(b); return ready; })
        .catch(function (err) { console.warn('[GC] could not pre-load the next designs; the button will fetch them on click', err); return null; })
        .then(function (r) { warming = null; return r; });
    }

    /* The batch for the button's current link: the pre-loaded one if it is ready or on its way, else fetched now. */
    function take() {
      var url = btn.href;
      if (ready && ready.url === url) { var b = ready; ready = null; return Promise.resolve(b); }
      return Promise.resolve(warming).then(function () {
        if (ready && ready.url === url) { var w = ready; ready = null; return w; }
        return fetchBatch(url).then(build);
      });
    }

    btn.addEventListener('click', function (e) {
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      var instant = !!(ready && ready.url === btn.href);
      if (!instant) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Loading…'; }
      take()
        .then(function (b) { reveal(b, true); prewarm(); })
        .catch(function (err) {
          console.error('[GC] load more failed, following the page link instead', err);
          location.href = btn.href;
        })
        .then(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
        });
    });

    /* Pre-load once every tile on the first page has finished loading, so it never competes with them. */
    function whenGridLoaded(cb) {
      var waiting = Array.prototype.filter.call(grid.querySelectorAll('img'), function (i) { return !i.complete; });
      if (!waiting.length) { cb(); return; }
      var left = waiting.length, done = false;
      var finish = function () { if (!done) { done = true; cb(); } };
      waiting.forEach(function (i) {
        var one = function () { if (--left <= 0) finish(); };
        i.addEventListener('load', one, { once: true });
        i.addEventListener('error', one, { once: true });
      });
      setTimeout(finish, 20000);
    }
    var startWarm = function () { whenGridLoaded(prewarm); };
    if (document.readyState === 'complete') startWarm(); else addEventListener('load', startWarm);

    addEventListener('pagehide', function () {
      var state = { n: batches, y: Math.round(scrollY), next: btn.isConnected ? btn.getAttribute('href') : '', count: count ? count.textContent : '', carry: shown.carry, owed: shown.owed };
      try { sessionStorage.setItem(key, JSON.stringify(Object.assign({ html: loadedHtml.join('') }, state))); }
      catch (err) {
        console.warn('gc-loadmore: could not keep the loaded designs for Back; keeping the count only', err);
        try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (err2) { console.warn('gc-loadmore: sessionStorage unavailable', err2); }
      }
    });

    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (err) { console.warn('gc-loadmore: saved state unreadable', err); }
    if (nav && nav.type === 'back_forward' && saved && saved.n > 1) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      if (saved.html) {
        /* Rebuilt from what this visit already fetched: no requests, and the images are in the browser cache. */
        carry = saved.carry || '';
        owed = !!saved.owed;
        shown = { carry: carry, owed: owed };
        var before = grid.children.length;
        grid.insertAdjacentHTML('beforeend', saved.html);
        unpin(Array.prototype.slice.call(grid.children, before));
        Array.prototype.slice.call(grid.children, before).forEach(function (n) {
          if (GC.progressive) GC.progressive.init(n);
          GC.boot(n);
        });
        loadedHtml = [saved.html];
        batches = saved.n;
        if (saved.count && count) count.textContent = saved.count;
        if (saved.next) btn.setAttribute('href', saved.next); else btn.remove();
        scrollTo(0, saved.y);
        requestAnimationFrame(function () { scrollTo(0, saved.y); });
      } else {
        var chain = Promise.resolve();
        for (var i = 1; i < saved.n; i++) chain = chain.then(function () { return btn.isConnected ? fetchBatch(btn.href).then(build).then(function (b) { reveal(b, false); }) : null; });
        chain.then(function () { scrollTo(0, saved.y); })
          .catch(function (err) { console.error('[GC] restoring the loaded designs failed', err); });
      }
    }
  });

  /* #4rrh2 ---------------- Mobile tab bar auto-hide ---------------- */

  GC.safe(function () {
    var bar = document.querySelector('[data-tabbar-autohide]');
    if (!bar) return;
    /* The sticky buy bar drops into the space the tab bar vacates rather than hiding
       with it — once the call to action is up it stays up. */
    var sticky = document.querySelector('[data-sticky-add]');
    function show() { bar.classList.remove('is-hidden'); if (sticky) sticky.classList.remove('is-low'); }
    function hide() { bar.classList.add('is-hidden'); if (sticky) sticky.classList.add('is-low'); }
    var lastY = window.scrollY;
    var acc = 0; /* accumulated scroll in one direction; small moves don't toggle */
    var THRESHOLD = 16;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      /* top of page (incl. iOS rubber-band) and bottom of page: always show */
      if (y <= 0) { show(); lastY = 0; acc = 0; return; }
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (y >= max - 2) { show(); lastY = y; acc = 0; return; }
      var delta = y - lastY;
      lastY = y;
      if ((delta > 0) !== (acc > 0)) acc = 0;
      acc += delta;
      if (acc > THRESHOLD) hide();
      else if (acc < -THRESHOLD) show();
    }, { passive: true });
  });

  /* #uu0ll ---------------- Form bot filter ---------------- */

  /* Cheap layer under Shopify's hCaptcha, which is the actual gate. Catches scripted
     fill-and-submit only; anything POSTing straight at Shopify never runs this. */
  GC.safe(function () {
    var MIN_DWELL = 2500; /* ms — below this, nobody read the form before sending it */

    document.querySelectorAll('[data-formguard-hp]').forEach(function (hp) {
      var form = hp.form;
      if (!form) return;
      var armed = Date.now();

      form.addEventListener('submit', function (e) {
        /* A person cannot fill a field parked 9999px off-screen. No second chance. */
        if (hp.value !== '') { e.preventDefault(); return; }

        /* Too fast is only suspicious, not proof — so say so and let them click
           again rather than swallowing a real visitor's letter in silence. */
        if (Date.now() - armed < MIN_DWELL) {
          e.preventDefault();
          armed = 0; /* next attempt always passes the clock */
          var warn = form.querySelector('[data-formguard-warn]');
          if (!warn) {
            warn = document.createElement('p');
            warn.className = 'gc-form-error';
            warn.setAttribute('data-formguard-warn', '');
            warn.textContent = 'That came through a little quickly — send it once more and it will reach us.';
            form.appendChild(warn);
          }
          return;
        }

        /* Clean submit: keep our plumbing out of the email Shopify sends. */
        hp.disabled = true;
      });
    });
  });

  /* #34dbg ---------------- Review photo viewer ---------------- */

  /* Opens a review thumbnail filled to the viewport — a 120px square cannot show how a
     print sits on a shirt. Delegated from the document, not bound per button: review
     cards render from three sections and the carousel can hold cards this never saw. */

  GC.safe(function () {
    var box = null, imgEl, countEl, shots = [], at = 0, opener = null;

    function build() {
      box = document.createElement('div');
      box.className = 'gc-revlb';
      box.innerHTML =
        '<div class="gc-revlb__pane"><img class="gc-revlb__img" alt=""></div>' +
        '<button type="button" class="gc-revlb__nav gc-revlb__nav--prev" aria-label="Previous photo">‹</button>' +
        '<button type="button" class="gc-revlb__nav gc-revlb__nav--next" aria-label="Next photo">›</button>' +
        '<button type="button" class="gc-revlb__close" aria-label="Close">×</button>' +
        '<p class="gc-revlb__count"></p>';
      document.body.appendChild(box);

      imgEl = box.querySelector('.gc-revlb__img');
      countEl = box.querySelector('.gc-revlb__count');

      box.querySelector('.gc-revlb__close').addEventListener('click', close);
      box.querySelector('.gc-revlb__nav--prev').addEventListener('click', function () { step(-1); });
      box.querySelector('.gc-revlb__nav--next').addEventListener('click', function () { step(1); });
      /* Clicking the ground closes; clicking the photo itself must not. */
      box.querySelector('.gc-revlb__pane').addEventListener('click', function (e) {
        if (e.target !== imgEl) close();
      });
    }

    function show() {
      imgEl.src = shots[at];
      countEl.textContent = (at + 1) + ' / ' + shots.length;
    }

    function step(by) {
      if (shots.length < 2) return;
      at = (at + by + shots.length) % shots.length;
      show();
    }

    function open(btn) {
      if (!box) build();

      /* The .gc-review__media container IS the group, so no minted id can disagree
         with it. Document order, so the arrows walk the photos as they appear. */
      var media = btn.closest('.gc-review__media');
      var peers = media ? media.querySelectorAll('[data-gc-revpic]') : [btn];

      shots = [];
      at = 0;
      Array.prototype.forEach.call(peers, function (p) {
        var im = p.querySelector('img');
        if (!im) return;
        if (p === btn) at = shots.length;
        shots.push(im.currentSrc || im.src);
      });
      if (!shots.length) return;

      opener = btn;
      box.classList.toggle('gc-revlb--single', shots.length < 2);
      box.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      layer.open();
      show();
      box.querySelector('.gc-revlb__close').focus();
    }

    function close() {
      if (!box) return;
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      imgEl.removeAttribute('src');
      layer.close();
      /* Send focus back where it came from, or a keyboard user is dropped at
         the top of the document with no idea what they just dismissed. */
      if (opener) { opener.focus(); opener = null; }
    }
    var layer = GC.backLayer(close);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-gc-revpic]');
      if (btn) { e.preventDefault(); open(btn); }
    });

    document.addEventListener('keydown', function (e) {
      if (!box || !box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  });

  /* #c2f8m ---------------- Card titles keep to the two lines every tile holds ----------------
     A title wraps balanced at full size; only one that would run to a third line steps down, no
     further than 82%. Never shrunk to squeeze onto one line: the second line is held anyway, so
     that only cost legibility. Every pass measures all queued titles at once, so a grid of 48 costs
     a few layouts, not 48. See docs/product-card.md. */
  var FIT_MIN = 0.82, fitQueue = [], fitPending = false;
  function fitCardNames() {
    fitPending = false;
    var els = fitQueue.filter(function (el) { return el.isConnected; });
    fitQueue = [];
    els.forEach(function (el) { el.style.fontSize = ''; });
    var tall = els.map(function (el) {
      var fs = parseFloat(getComputedStyle(el).fontSize);
      return { el: el, fs: fs, base: fs, min: fs * FIT_MIN };
    });
    /* Lines counted from the text's own boxes: scrollHeight counts the blackletter's ink overhang and called two lines three. */
    var over = function (t) {
      var r = document.createRange(), seen = {}, n = 0;
      r.selectNodeContents(t.el);
      Array.prototype.forEach.call(r.getClientRects(), function (q) {
        var k = Math.round(q.bottom);
        if (q.width > 0 && !seen[k]) { seen[k] = 1; n++; }
      });
      return n > 2;
    };
    for (var pass = 0; tall.length && pass < 12; pass++) {
      tall = tall.filter(over);
      tall.forEach(function (t) { t.fs = Math.max(t.min, t.fs - 0.5); t.el.style.fontSize = t.fs + 'px'; });
      tall = tall.filter(function (t) { return t.fs > t.min; });
    }
  }
  function queueFit(el) {
    if (fitQueue.indexOf(el) === -1) fitQueue.push(el);
    if (!fitPending) { fitPending = true; requestAnimationFrame(function () { GC.safe(fitCardNames); }); }
  }
  function refitAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-card-name]'), queueFit); }
  GC.register('[data-card-name]', queueFit);
  if (document.fonts) {
    document.fonts.ready.then(refitAll);
    document.fonts.addEventListener('loadingdone', refitAll);
  }
  var fitW = window.innerWidth, fitT;
  window.addEventListener('resize', function () {
    clearTimeout(fitT);
    fitT = setTimeout(function () { if (window.innerWidth !== fitW) { fitW = window.innerWidth; refitAll(); } }, 100);
  });
})();
